import { Right } from "@insightfulscience/shared-utils/either";

/** @type {
	(setId: string, plasmidId: string) =>
	(deps: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }) => Promise<Right<string>>
} */
const getPlasmidStaticMap =
	(setId, plasmidId) =>
	({ sgApiClient }) =>
		sgApiClient.getPlasmidStaticImage(setId, plasmidId).then(Right);

export default getPlasmidStaticMap;
